"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var accordion_1 = require("../modules/accordion");
var get_element_1 = require("../utils/get_element");
var IDS = {
    DETAILS_CONTAINER: 'js-guide-detail-container',
};
var CLASSES = {
    PAGE_TOP_BUTTON: 'js-page-top-button',
};
var guideDetailsContainer = (0, get_element_1.getElementById)(IDS.DETAILS_CONTAINER);
new accordion_1.Accordion(guideDetailsContainer);
var pageTopButton = document.querySelectorAll(".".concat(CLASSES.PAGE_TOP_BUTTON));
pageTopButton.forEach(function (button) {
    button.addEventListener('click', function () {
        window.scrollTo({
            top: 0,
            behavior: 'smooth',
        });
    });
});
